import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { ENV } from '@app/env';
import { Observable } from 'rxjs/Observable';
import { IFavorites } from '../models/favorites.model';
import { ICatalog } from '../models/catalog.model';
import * as firebase from 'firebase';
import { ICommercialSample } from '../models/commercial_sample.model';
import { IStaffData } from '../models/staff.model';
import { IEvent } from '../models/client.model';

@Injectable()
export class FavoritesData {

  public clientId = ENV.client;

  constructor(
    private afDatabase: AngularFireDatabase,
  ) { }

  getFavorites(userId: string): Observable<IFavorites[]> {
    return this.afDatabase.list<any>(`/Clients/${this.clientId}/UserFavorites/${userId}/`).valueChanges();
  }

  getFavoritesProduct(userId: string): Observable<IFavorites[]> {
    return this.afDatabase.list<any>(`/Clients/${this.clientId}/UserFavorites/${userId}/`).valueChanges();
  }

  getFavorite(userId: string, favoriteId: string) {
    return this.afDatabase.object<any>(`/Clients/${this.clientId}/UserFavorites/${userId}/${favoriteId}`).valueChanges();
  }


  addFavoriteCatalog(userId: string, catalog: ICatalog) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${catalog.id}`).set({
      id: catalog.id,
      type: "product",
      created_at: firebase.database.ServerValue.TIMESTAMP
    })
  }

  addFavoriteStaff(userId: string, staffid: string, stafffConfig: string, eventId?: string, moduleName?: string) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${staffid}`).set({
      id: staffid,
      type: "staff",
      idConfig: stafffConfig,
      eventId: eventId,
      nameModule: moduleName,
      created_at: firebase.database.ServerValue.TIMESTAMP
    })
  }

  addFavoriteAgenda(userId: string, agendaId: string, eventId: string) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${agendaId}`).set({
      id: agendaId,
      eventId: eventId,
      type: "agenda",
      created_at: firebase.database.ServerValue.TIMESTAMP
    })
  }

  addFavoriteCommercialSample(userId: string, sample: ICommercialSample, eventId?: string, nameModule?) {
    if (eventId) {
      return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${sample.id}`).set({
        id: sample.id,
        nameModule: nameModule,
        type: "stand",
        created_at: firebase.database.ServerValue.TIMESTAMP,
        eventId: eventId
      })
    }
    else {
      return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${sample.id}`).set({
        id: sample.id,
        type: "stand",
        nameModule: nameModule,
        created_at: firebase.database.ServerValue.TIMESTAMP,
      })
    }

  }

  addFavoriteEvent(userId: string, event: IEvent) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${event.id}`).set({
      id: event.id,
      type: "event",
      created_at: firebase.database.ServerValue.TIMESTAMP
    })
  }

  removeItem(userId, itemId) {
    return this.afDatabase.object(`/Clients/${this.clientId}/UserFavorites/${userId}/${itemId}`).remove();
  }

  validateAddFavoriteRef(userId, idItem, clientId) {
    return this.afDatabase.object(`/Clients/${clientId}/UserFavorites/${userId}/${idItem}`).query.ref;
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/favorites.ts